import { Buy } from "./buy";
import { BuyOutline } from "./buy-outline";
import { Cart } from "./cart";
import { Wallet } from "./wallet";
import { ArrowForward } from "./arrow-forward";
import { Instagram } from "./instagram";
import { WhatsApp } from "./whatsapp";
import { LinkedIn } from "./linkedin";
import { Check } from "./check";
import { Facebook } from "./facebook";
import { Logistics } from "./logistics";
import { Market } from "./market";
import { Package } from "./package";
import { Ship } from "./ship";
import { Store } from "./store";
import { Twitter } from "./twitter";
import { Eye } from "./eye";
import { EyeOff } from "./eye-off";
import { Menu } from "./menu";
import { Settings } from "./settings";
import { UserIcon } from "./user";
import { Notification } from "./notification";
import { TrendUp } from "./trend-up";
import { Coins } from "./coins";
import { MoneyIcon } from "./money";
import { ArrowUp } from "./arrow-up";
import { AirplanIcon } from "./airplane";
import { Info } from "./info";
import { UsersFour } from "./users-four";
import { RewardIcon } from "./reward";
import { Tracker } from "./tracker";
import { DollarSign } from "./dollar-sign";
import { Calculator } from "./calculator";
import { ArrowRight } from "./arrow-right";
import { Bell } from "./bell";
import { Blog } from "./blog";
import { BookMark } from "./bookmark";
import { Calender } from "./calender";
import { Cancel } from "./cancel";
import { ChatIcon } from "./chat";
import { GoogleMeet } from "./google-meet";
import { Zoom } from "./zoom";
import { Parcel } from "./parcel-v2";
import { ParcelIcon } from "./parcel";
import { EmptyWallet } from "./empty-wallet";
import { Track } from "./track";
import { UserFill } from "./user-fill";
import { UserDetails } from "./user-details";
import { People } from "./people";
import { DeliveryIcon } from "./deliver";
import { MoneyBag } from "./money-bag";

export const iconsMap = {
  airplane: <AirplanIcon />,
  arrowForward: <ArrowForward />,
  arrowRight: <ArrowRight />,
  arrowUp: <ArrowUp />,
  bell: <Bell />,
  blog: <Blog />,
  bookMark: <BookMark />,
  buy: <Buy />,
  buyOutline: <BuyOutline />,
  calculator: <Calculator />,
  calender: <Calender />,
  cancel: <Cancel />,
  cart: <Cart />,
  chat: <ChatIcon />,
  check: <Check />,
  coins: <Coins />,
  delivery: <DeliveryIcon />,
  deposits: <ArrowUp />,
  dollarSign: <DollarSign />,
  emptyWallet: <EmptyWallet />,
  eye: <Eye />,
  eyeOff: <EyeOff />,
  facebook: <Facebook />,
  googleMeet: <GoogleMeet />,
  instagram: <Instagram />,
  info: <Info />,
  linkedin: <LinkedIn />,
  logistics: <Logistics />,
  market: <Market />,
  menu: <Menu />,
  money: <MoneyIcon />,
  moneyBag: <MoneyBag />,
  notification: <Notification />,
  package: <Package />,
  parcel: <Parcel />,
  parcelIcon: <ParcelIcon />,
  people: <People />,
  reward: <RewardIcon />,
  settings: <Settings />,
  ship: <Ship />,
  store: <Store />,
  twitter: <Twitter />,
  track: <Track />,
  tracker: <Tracker />,
  trend: <TrendUp />,
  user: <UserIcon />,
  userFill: <UserFill />,
  userDetails: <UserDetails />,
  users: <UsersFour />,
  whatsapp: <WhatsApp />,
  wallet: <Wallet />,
  withdrawals: <ArrowUp className="-rotate-90" />,
  zoom: <Zoom />,
};
